import { render } from "./TitleYearLabel.vue?vue&type=template&id=74b67148&ts=true"
import script from "./TitleYearLabel.vue?vue&type=script&lang=ts"
export * from "./TitleYearLabel.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__